export interface SalesOrderDeposit {
  id: string;
  salesOrderHeaderId: string;
  salesOrderNo: string;
  customerKey: string;
  customerName: string;
  customerOrderNo: string;
  customerOrderRef: string;
  orderStatus: string;
  orderType: string;
  currency: string;
  orderValue: number;
  dateOrdered: Date;
  dateEntered: Date;
  depositEnteredById: string;
  dateDepositEntered: Date;
  depositEnteredByName: string;
  depositAmount: number;
  notes: string;
  depositPrintedById: string;
  depositPrintedByName: string;
  depositPrintedDate: Date;
  salesInvoiceHeaderId: string;
  salesInvoiceNo: string;
  selected: boolean;
  depositInvoicePaidYesNo: string;
  depositInvoicePaid: boolean;
  dateDepositInvoicePaid: Date;
  depositInvoicePaidById: string;
  depositInvoicePaidByName: string;
  earliestDelivery: Date;
  deliveryAddress: string;
}
